module.exports = __webpack_public_path__ + "static/media/belief-1.ad980a75.jpg";